import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '~/components/Spinner';
import * as artifactActions from '~/artifact/actions';
type ArtifactViewMainContentFixInfoHowToFixPackageManageGoGetProps = {
  component: object;
  range?: object;
  safeVersion?: string;
  transitive?: boolean;
  unsafeVersion?: string;
  artifactState: object;
  actions: object;
};
class ArtifactViewMainContentFixInfoHowToFixPackageManageGoGet extends React.Component<
  ArtifactViewMainContentFixInfoHowToFixPackageManageGoGetProps,
  {}
> {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    const { component } = this.props;
    this.props.actions.checkIfComponentHeadSafe(component.id);
  }
  render() {
    const { component, artifactState = {} } = this.props;
    const { componentHeadSafeState = {} } = artifactState;
    const { [component.id]: componentData = {}, isFetching } = componentHeadSafeState;
    if (isFetching) {
      return <Spinner size={15} strokeWidth={4} />;
    }
    return (
      <div>
        {componentData.hasVulns ? (
          <span>
            <div className="grid pt">
              <span className="grid__item pv- pl--">
                Unfortunately <strong>go get</strong> only supports updating a library to the latest
                commit. The latest commit of the <strong>{component.coordinate1}</strong> has
                vulnerabilities. Consider using a package manager that allows you to upgrade to a
                particular commit such as <strong>glide</strong>
              </span>
            </div>
          </span>
        ) : (
          <span>
            <div className="grid pt">
              <span className="grid__item pv- pl--">
                Unfortunately <strong>go get</strong> only supports updating a library to the latest
                commit. The latest commit of <strong>{component.coordinate1}</strong> does not have
                vulnerabilities. Run this to upgrade your library
              </span>
            </div>
            <div className="pt-- -ml mt-">
              <span className="font-family--code bg-color--white-medium p-">
                go get -u {component.name}
              </span>
            </div>
          </span>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentFixInfoHowToFixPackageManageGoGet);
